import React from 'react';
import getCredenzialiUtente from '../services/getCredenzialiUtente';
import { NineCellLoading } from 'react-loadingg';
import {QRCodeSVG} from 'qrcode.react';
import translateString from '../utils/Locales';
import getClient from '../services/getClient';
import {isMobile} from 'react-device-detect';

const qs = require('querystring');
let t = translateString;

export default class UserToken extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            recupero: false, 
        };
    }

    handleResize() {
        this.setState({ width: window.innerWidth < 1100 ? '80%' : '40%', margin: window.innerWidth < 1100 ? '10%' : '30%' });
    }

    async componentDidMount() {
        this.resizeListener = window.addEventListener('resize', () => this.handleResize());
        this.handleResize();

        const parsed = qs.parse(window.location.hash);
        
        const userDb = parsed['db'];
        const userToken = parsed['#/usertoken?token'];
        const mode = parsed['mode'];

        if (mode === 'recupero') {
            this.setState({ recupero: true });
        }

        if (userToken !== undefined && userToken !== '' && userDb !== undefined && userDb !== '') {
            this.cliente = await getClient('', '', userDb);
            let user = await getCredenzialiUtente(userToken, userDb);
            if (user.length > 0) {
                this.utente = user[0];
                this.userDb = userDb;
                this.setState({ isLoading: false });
                if (isMobile) {
                    window.location.href = 'academy://' + this.userDb + '___' + this.utente.username + '___' + this.utente.clear_password;
                }
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener(this.resizeListener);
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading />;
        else return(
            <div style={{ width: '100%', textAlign: 'center', paddingTop: 100, alignContent: 'center' }}>
                <img style={{ position: 'absolute', top: 20, left: 30, height: 60, width: 'auto' }} src={ this.cliente.logoImage !== '' ? this.cliente.logoImage : require('../images/icon.png')} />
                <div style={{ width: this.state.width, backgroundColor: 'white', marginBottom: 100, padding: 40, marginLeft: this.state.margin, textAlign: 'center' }}>
                        <h3 style={{ border: '1px solid #C4674E', borderRadius: '10px', paddingTop: 10, paddingBottom: 10, paddingLeft: 20, paddingRight: 20, width: '90%', textAlign: 'center', marginLeft: '5%', color: '#C4674E', marginBottom: 40, fontWeight: 'bold', fontSize: 20 }}>{t('attenzione_p')}</h3>
                        <QRCodeSVG value={this.userDb + '___' + this.utente.username + '___' + this.utente.clear_password} style={{ height: 200, width: 200 }} bgColor={'transparent'} />
                        <h4 style={{ margin: 30 }}>{t('ciao_utente') + this.utente.username}</h4>
                        <p style={{ marginTop: -10, fontSize: 20, fontWeight: 'bold' }}>{t('tuo_qr')}</p>
                        <p style={{ marginTop: 40, textAlign: 'left'  }}>{t('ricorda')}</p>
                        { this.state.recupero && (
                            <div style={{ marginBottom: 40 }}>
                                <p style={{ marginTop: 30, textAlign: 'left'  }}>{t('le_cred')}</p>
                                <p style={{ marginTop: 10, textAlign: 'left'  }}><b>{t('cliente')}:</b> {this.userDb}</p>
                                <p style={{ marginTop: 5, textAlign: 'left'  }}><b>Username:</b> {this.utente.username}</p>
                                <p style={{ marginTop: 5, textAlign: 'left'  }}><b>Password:</b> {this.utente.clear_password}</p>
                            </div>
                        )}
                        <p style={{ marginTop: 10, textAlign: 'left' }}>{t('istruzioni')}</p>
                        <p style={{ marginTop: 5, textAlign: 'left', marginLeft: 20 }}>{t('istruzioni_1')}</p>
                        <p style={{ marginTop: 5, textAlign: 'left', marginLeft: 20 }}>{t('istruzioni_2')}</p>
                        <p style={{ marginTop: 5, textAlign: 'left', marginLeft: 20 }}>{t('istruzioni_3')}</p>
                        <p style={{ marginTop: 20, textAlign: 'left' }}>{t('oppure')}</p>
                        <div style={{ width: '200px', marginLeft: 'calc((100% - 200px)/2)', marginTop: 30, height: 40, borderRadius: '10px', cursor: 'pointer', backgroundColor: 'orange', padding: 10, color: 'white' }} onClick={() => window.location.href = 'academy://' + this.userDb + '___' + this.utente.username + '___' + this.utente.clear_password }>{t('apri_app')}</div>
                </div>
            </div>
        );
    }
}